import { render, staticRenderFns } from "./NotificacoesOrganizacao.vue?vue&type=template&id=cb56893a"
import script from "./NotificacoesOrganizacao.vue?vue&type=script&lang=js"
export * from "./NotificacoesOrganizacao.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports